<div class="app-menu-popup">
  <ng-template [cdkPortalOutlet]="componentPortal"></ng-template>
</div>
